import React, { useState } from 'react';

function SapApprovalModal({ isOpen, onClose, onSubmit, requisition, currentUser, originalUser, isMasquerading }) {
  const [sapDraftNumber, setSapDraftNumber] = useState(requisition?.requisition_sap_approve || '');
  const [copyMe, setCopyMe] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!sapDraftNumber.trim()) {
      return;
    }

    setLoading(true);
    try {
      // Prepare the SAP data to pass to the parent
      const sapData = {
        sap_draft_number: sapDraftNumber.trim(),
        CC: copyMe ? '1' : ''
      };
      
      console.log('🔍 SapApprovalModal submitting data:', sapData);
      
      await onSubmit(sapData);
      onClose();
    } catch (error) {
      console.error('Error requesting SAP approval:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-full max-w-md shadow-lg rounded-md bg-white">
        <div className="flex justify-between items-center pb-3">
          <h3 className="text-lg font-bold text-gray-900">Request SAP Draft Approval</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <span className="sr-only">Close</span>
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Show masquerading context if applicable */}
        {isMasquerading && currentUser && originalUser && (
          <div className="mb-4 p-3 bg-purple-50 border border-purple-200 rounded-md">
            <div className="flex items-center">
              <svg className="w-4 h-4 text-purple-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              <div className="text-sm">
                <span className="font-medium text-purple-800">Requesting SAP approval as: </span>
                <span className="text-purple-700">
                  User ID: {currentUser.user_id} ({currentUser.user_full_name || currentUser.user_name || currentUser.name || 'Name not available'})
                </span>
              </div>
            </div>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              SAP Draft Number
            </label>
            <input
              type="text"
              value={sapDraftNumber}
              onChange={(e) => setSapDraftNumber(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter SAP draft number"
              required
            />
          </div>

          <div className="mb-6">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={copyMe}
                onChange={(e) => setCopyMe(e.target.checked)}
                className="mr-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              />
              <span className="text-sm text-gray-700">Copy Me</span>
            </label>
          </div>

          <div className="flex justify-end">
            <button
              type="submit"
              disabled={loading || !sapDraftNumber.trim()}
              className={`w-full px-4 py-2 rounded-md disabled:cursor-not-allowed flex items-center justify-center ${
                loading 
                  ? 'bg-blue-400 text-white cursor-wait' 
                  : 'bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50'
              }`}
            >
              {loading && (
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              )}
              {loading ? 'Sending Request...' : 'Send Request'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SapApprovalModal;
